export default __webpack_public_path__ + "static/media/baner6.af850453.jpg";